  
import axiosInstance, { getAPIURL } from "../axiosInstance";
import { useQuery } from "@tanstack/react-query";
import { FindPostsResponse, Params } from "../../types/Types";

export function useGetAllPosts({
  enabled = true,
  pageSize = 10,
  page = 1,
}: Params = {}) {
  return useQuery({
    enabled,
    queryKey: ['posts', { pageSize, page }],
    queryFn: async () => {
      const url = getAPIURL(`/Post/All?pageNumber=${page}&pageSize=${pageSize}`);
      return axiosInstance<FindPostsResponse>(url).then((res) => res.data);
    },
  });
}